import { Box, BoxProps } from "@chakra-ui/react";

type BadgeProps = {
  size?: "small" | "medium" | "large";
  color?: string;
} & BoxProps;

const sizesMap = {
  small: "6px",
  medium: "12px",
  large: "16px",
};

export function Badge({ size = "medium", color = "pinkFlink.500", ...rest }: BadgeProps) {
  const sizeValue = sizesMap[size];

  return <Box bg={color} height={sizeValue} width={sizeValue} borderRadius="50%" {...rest} />;
}
